<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import TeamForm from '../TeamForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    TeamForm,
    PageHeader,
    Spinner,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const teamId = Number(to.params.teamId);
      const currentUser = vm.$store.getters.getCurrentUser;
      const accountId = vm.$store.getters.getCurrentAccountId;
      const currentAccount = currentUser.accounts?.find(
        acc => Number(acc.id) === Number(accountId)
      );

      // Check permissions
      const permissions = currentAccount?.permissions || [];
      const customRole = currentAccount?.custom_role;

      // Check if user is admin without a custom role
      if (currentAccount?.role === 'administrator' && !customRole) {
        return;
      }

      if (!permissions.includes('settings_teams_manage')) {
        useAlert('You do not have permission to configure this team');
        router.push({ name: 'settings_teams_list' });
        return;
      }

      const allowedIds = customRole?.allowed_team_ids || [];
      const configurableIds = customRole?.configurable_team_ids || [];
      const hasAccessRestrictions = allowedIds.length > 0;

      // Check if user has access to view this team
      if (hasAccessRestrictions && !allowedIds.includes(teamId)) {
        useAlert('You do not have permission to configure this team');
        router.push({ name: 'settings_teams_list' });
        return;
      }

      // Check configuration permissions
      if (hasAccessRestrictions && configurableIds.length === 0) {
        useAlert('You do not have permission to configure this team');
        router.push({ name: 'settings_teams_list' });
        return;
      }

      if (configurableIds.length > 0 && !configurableIds.includes(teamId)) {
        useAlert('You do not have permission to configure this team');
        router.push({ name: 'settings_teams_list' });
      }
    });
  },
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    teamData() {
      const { teamId } = this.$route.params;
      return this.$store.getters['teams/getTeam'](teamId);
    },
    showTeamForm() {
      const { id } = this.teamData;
      return id && !this.uiFlags.isFetching;
    },
    ...mapGetters({
      uiFlags: 'teams/getUIFlags',
    }),
  },
  methods: {
    async updateTeam(data) {
      try {
        const { teamId } = this.$route.params;

        await this.$store.dispatch('teams/update', {
          id: teamId,
          ...data,
        });

        router.replace({
          name: 'settings_teams_edit_members',
          params: {
            page: 'edit',
            teamId,
          },
        });
      } catch (error) {
        useAlert(this.$t('TEAMS_SETTINGS.TEAM_FORM.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div
    class="border border-n-weak bg-n-solid-1 rounded-t-lg border-b-0 h-full w-full p-6 col-span-6 overflow-auto"
  >
    <PageHeader
      :header-title="$t('TEAMS_SETTINGS.EDIT_FLOW.CREATE.TITLE')"
      :header-content="$t('TEAMS_SETTINGS.EDIT_FLOW.CREATE.DESC')"
    />
    <div class="flex flex-wrap">
      <TeamForm
        v-if="showTeamForm"
        :on-submit="updateTeam"
        :submit-in-progress="false"
        :submit-button-text="$t('TEAMS_SETTINGS.EDIT_FLOW.CREATE.BUTTON_TEXT')"
        :form-data="teamData"
      />
      <Spinner v-else />
    </div>
  </div>
</template>
